// extracted by mini-css-extract-plugin
export var leftAlign = "_26-2";
export var popper = "_26-0";
export var subtitle = "_26-1";